import React, {useState, useEffect} from 'react';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {FormattedMessage} from 'react-intl';
import {Document, Page} from 'react-pdf';
import Spinner from '../../../_common/components/Spinner';
import Empty from '../../../_common/components/Empty';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import styles from './styles.module.scss';

const PopupPreviewDocument = ({
                                buttonType = 'icon',
                                documentPath,
                                handlePreviewDocument,
                                allowHandlePreviewDocument,
                                disableButton = false
                              }) => {
  const [link, setLink] = useState('');
  const [show, setShow] = useState(false);
  const handleCloseModal = () => {
    setShow(false);
    setLink('');
  };
  const handleShowModal = () => setShow(true);

  useEffect(() => {
    setLink(documentPath);
  }, [documentPath]);

  return (
    <>
      <ButtonAction
        variant={buttonType}
        iconButtonType={'success'}
        label={buttonType === 'icon'
          ? <img src={toAbsoluteUrl('/media/common/Eye_green.svg')} alt="icon" className="w-20px h-20px"/>
          : <div>
            <img src={toAbsoluteUrl('/media/common/Eye_white.svg')} alt="icon" className="w-20px h-20px"/>
            <span className='text-truncate'>
          <FormattedMessage
            id="customer-details-documentInfo-label-button-view"
            defaultMessage="Preview"
          />
        </span>
          </div>
      }
        onClick={() => {
          handleShowModal();
          if (allowHandlePreviewDocument) {
            handlePreviewDocument();
          }
        }}
        disabled={disableButton}
        customClassnames={`mx-2 ${buttonType === 'success' ? buttonSubmit : ''}`}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'lg'}>
        <div className={styles.popupPreviewDocumentContainer}>
          <Document
            file={link}
            loading={
              <div className={styles.iconContainer}>
                <Spinner/>
              </div>
            }
            noData={
              <div className={styles.iconContainer}>
                <Empty/>
              </div>
            }
          >
            <Page pageNumber={1}/>
          </Document>
        </div>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            label={<FormattedMessage id="button-close" defaultMessage="Close"/>}
            onClick={handleCloseModal}
            customClassnames={buttonCancel}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupPreviewDocument;